<template>
  <sn-modal
    v-model="showModal"
    type="decision"
    title="Discard changes?"
    data-cy="discard-changes-modal"
    primary-text="Yes"
    secondary-text="Cancel"
    @submit="handleDiscardChanges"
    @input="cancel"
  >
    <span>There are unsaved edits on this page. Tap yes to discard those changes.</span>
  </sn-modal>
</template>

<script>

export default {
  name: 'DiscardChangesModal',
  props: {
    toggleModal: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      showModal: false
    }
  },
  watch: {
    toggleModal () {
      this.showModal = this.toggleModal
    }
  },
  methods: {
    handleDiscardChanges () {
      this.$emit('close')
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>

@import '~/assets/css/snui';

</style>
